import { render, staticRenderFns } from "./community-index.vue?vue&type=template&id=e88d0a34&scoped=true"
import script from "./community-index.vue?vue&type=script&lang=js"
export * from "./community-index.vue?vue&type=script&lang=js"
import style0 from "./community-index.vue?vue&type=style&index=0&id=e88d0a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d0a34",
  null
  
)

export default component.exports